import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Box, Stack, Container, Button, AppBar, Toolbar, Menu, MenuItem, Avatar, Tooltip, Typography, IconButton, ListItem, ListItemText, ListItemIcon} from "@mui/material";
import { ReactComponent as RegisterIcon } from "./assets/App-Registration--Streamline-Rounded-Material-Symbols.svg";
import { ReactComponent as ManageIcon } from "./assets/Settings-Motion-Mode--Streamline-Rounded-Material-Symbols.svg";
import { ReactComponent as LogoutIcon } from "./assets/Logout-1--Streamline-Ultimate.svg";
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { ReactComponent as LogoWhiteIcon } from "./assets/logo_white.svg";
import {keycloak} from "./config/auth";


function MainNavigation() {
    const navigate = useNavigate(); // This will now work because it's within the Router context
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [anchorElUser, setAnchorElUser] = useState(null);
    const isAuth = keycloak?.authenticated || false;
    // console.log(keycloak);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const pages = [
        { label: "Manage", icon: <ManageIcon className="top-nav-icon"/>, path: "/management" },
    ];
    return (
        <AppBar position="static" className="top_navigation">
            <Container maxWidth="lg">
                <Toolbar disableGutters sx={{justifyContent: "space-between"}}>
                    {/* Mobile Navigation */}
                    <Box sx={{ flexGrow: 0 }}>
                        <Link to="/"><LogoWhiteIcon style={{ width: "20%", height: "15%", paddingTop: "0.5em", paddingBottom: "0.5em", marginRight: "2em", cursor: "pointer" }} /></Link>
                    </Box>
                    {isAuth && (<Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            className="grey-background-mobile"
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page.label} onClick={() => { navigate(page.path); handleCloseNavMenu(); }} className="grey-background-mobile">
                                    <ListItemIcon>
                                        {page.icon}
                                    </ListItemIcon>
                                    <ListItemText sx={{ textAlign: 'center', fontWeight: "600" }}>{page.label}</ListItemText>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box> )}
                    {/* Desktop Navigation */}
                    {isAuth && (<Box sx={{ marginRight: "2em", flexGrow: 1, gap: "1em", display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page.label}
                                onClick={() => { navigate(page.path); handleCloseNavMenu(); }}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                                startIcon={page.icon}
                            >
                                <Typography variant="body2" sx={{ fontWeight: "400", textTransform: "none" }}>{page.label}</Typography>
                            </Button>
                        ))}
                    </Box>)}
                    {/* !isAuth && (<Box sx={{ flexGrow: 0 }}>
                        <Button
                            onClick={() => {
                                keycloak.login({
                                    redirectUri: window.location.origin + "/management", // Specify the redirect URI
                                });
                            }}
                            variant="contained"
                            className="white-button"
                        >
                            Login
                        </Button>
                        </Box>) */}
                    {isAuth && (<Box sx={{ flexGrow: 0 }}>
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                            <Avatar sx={{ bgcolor: "#cdd5df" }}><AccountCircle /></Avatar>
                        </IconButton>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <MenuItem onClick={() => {
                                var base_url = window.location.origin;
                                keycloak.logout({ redirectUri: base_url });
                            }}>
                                <ListItemIcon>
                                    <LogoutIcon style={{ width: "32px" }} />
                                </ListItemIcon>
                                <ListItemText sx={{ paddingLeft: "1em" }}>Logout</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Box>)}
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default MainNavigation;
